module.exports = __webpack_public_path__ + "static/media/m_beard_stubble_round_black.d23426a8.png";